import React from 'react';
import { useIntl } from 'react-intl';
import Html from 'components/html';

import { testId } from './your-content-banner.settings';
import messages from './your-content-banner.i18n';
import styles from './your-content-banner.module.scss';

const YourContentBanner: React.FunctionComponent<unknown> = () => {
  const { formatMessage } = useIntl();
  const translation = messages.pages.landing.yourContentBanner.livejasmin;

  return (
    <Html.div className={[styles.yourContentBanner, 'px-4 py-10 w-100']} testId={testId.component}>
      <Html.div className={[styles.yourChoice, 'mb-3']}>
        {formatMessage(translation.yourChoice, {
          b: (contents: React.ReactNode) => <Html.b className={styles.highlight}>{contents}</Html.b>,
        })}
      </Html.div>
      <Html.div className={styles.embrace}>{formatMessage(translation.embrace)}</Html.div>
    </Html.div>
  );
};

export default YourContentBanner;
